module.exports = __webpack_public_path__ + "img/sub_main_보도자료.ac6ecbb6.png";